import React from "react"
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import { haveAuth } from "utils"
import OrderDetailReadySmsButton from "./OrderDetailReadySmsButton"
import classes from "./OrderReadyViewedStatus.module.scss"

const OrderReadyViewedStatus = props => {
  const { order } = props

  const [t] = useTranslation()

  if (!order.isOrderReady) return null

  const showReadyOrderSmsTab =
    order.customerMobilePhone &&
    haveAuth(["smsOrderIsReady"]) &&
    (
      order.orderStatus === "paid" ||
      order.orderStatus === "pending"
    )

  return (
    <div className={classes["container"]}>
      {order.orderReadyStatusViewed
        ?
        <div className={classes["text-green"]}>
          <FaCheckCircle size={16} />

          <span className={classes["text"]}>
            {t("مشتری_پیام_آماده_تحویل_را_مشاهده_کرده_است")}
          </span>
        </div>
        :
        <div className={classes["text-red"]}>
          <FaTimesCircle size={16} />

          <span className={classes["text"]}>
            {t("پیام_آماده_تحویل_مشاهده_نشده_است")}
          </span>
        </div>
      }

      {
        showReadyOrderSmsTab &&
        <OrderDetailReadySmsButton
          order={order}
        />
      }
    </div>
  )
}

export default OrderReadyViewedStatus